import i18next from 'i18next';

import { getTheme } from '@commons/utils/theme';
import { METRIC_TYPE } from '../../common/utils';

const theme = getTheme();

// Channel types
export const CHANNELS = {
  DINE_IN: 'eatin',
  TAKEAWAY: 'takeaway',
  DELIVERY: 'delivery',
};

export const DELIVERY_PLATFORMS = {
  UBEREATS: 'ubereats',
  DELIVEROO: 'deliveroo',
  OTHER: 'other',
};

export const COLORS = {
  delivery: theme.colors.blue, // blue
  takeaway: theme.colors.infoGreen, // green
  eatin: theme.colors.infoOrange, // orange
  ubereats: theme.colors.black, // ubereats
  deliveroo: '#00ccbc', // deliveroo
  other: theme.colors.greys.medium, // other
};

export const CHANNEL_LABELS = () => ({
  delivery: i18next.t('ANALYSIS.PERFORMANCE.DELIVERY'),
  takeaway: i18next.t('ANALYSIS.PERFORMANCE.TAKEAWAY'),
  eatin: i18next.t('ANALYSIS.PERFORMANCE.DINE_IN'),
  ubereats: i18next.t('ANALYSIS.PERFORMANCE.UBEREATS'),
  deliveroo: i18next.t('ANALYSIS.PERFORMANCE.DELIVEROO'),
  other: i18next.t('ANALYSIS.PERFORMANCE.OTHER'),
});

// Metric type options (CA or Tickets)
export const METRIC_TYPE_OPTIONS = () => [
  {
    id: 'amountExcludingTaxes',
    name: i18next.t('GENERAL.TURNOVER_EX_TAX'),
    type: METRIC_TYPE.CURRENCY,
    key: 1,
  },
  {
    id: 'transactionCount',
    name: i18next.t('ANALYSIS.PERFORMANCE.TICKETS'),
    type: METRIC_TYPE.INTEGER,
    key: 2,
  },
];

// Display format options (Value or Percentage)
export const DISPLAY_FORMAT_IS_PERCENTAGE = [
  {
    id: false,
    key: 1,
    name: '123',
  },
  {
    id: true,
    key: 2,
    name: '%',
  },
];
